import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { HttpclientService } from "../../../shared/services/httpclient.service";

@Injectable()
export class InfractionService {
	constructor(private httpclientService: HttpclientService) {}
	loadINFRACTIONList(applicationItemID, schoolID) {
		var postResult$ = new Subject();
		var url = "Report/InfractionRPTGetList?ApplicationItemID=" + applicationItemID + "&SchoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
